const preventEventPropagation = (e) => {
  e.stopPropagation();
};
export default preventEventPropagation;